import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "react-toastify/ReactToastify.css";
import "./helper/Toast/toastify.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./helper/i18n_init";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(<App />);

/**
 * Reload once when a new service worker takes control so users see the latest build.
 */
let isRefreshing = false;

if ("serviceWorker" in navigator) {
	navigator.serviceWorker.addEventListener("controllerchange", () => {
		if (isRefreshing) {
			return;
		}

		isRefreshing = true;
		window.location.reload();
	});
}

serviceWorkerRegistration.register({
	onUpdate: (registration) => {
		if (registration && registration.waiting) {
			registration.waiting.postMessage({ type: "SKIP_WAITING" });
		}
	},
});

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

